// extracted by mini-css-extract-plugin
export default {"block":"aGtP8J","alignXLeft":"bGtP8J","alignXCenter":"cGtP8J","alignXRight":"dGtP8J","alignYTop":"eGtP8J","alignYCenter":"fGtP8J","alignYBottom":"gGtP8J"};